import react, { useEffect, useRef, useState } from "react";
import "../styles/PatientReportFileTemplateCreate.scss";
import {
  postPrescriptionTemplate,
  postPatientReport,
  postAppointment,
} from "../Redux/Thunk/Actions";
import {
  prescriptionType,
  patientid,
  secondPageTemplateId,
} from "../Redux/Slice/rootSlice";
import headerimage from "../assets/images/ascas.svg";

import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { updatePrescriptionType } from "../Redux/Slice/rootSlice";
import codoid from "../assets/images/logo.png";
import Headers from "./Header/Headers";

function RilReportTemplate(props) {
  const selectedTab = useSelector((state) => state.counter.prescriptionType);
  const patientId = useSelector((state) => state.counter.patientid);
  const [show, setshow] = useState(false);
  const [NumToWords, setNumToWords] = useState(0);
  const Content = useRef();
  const [valueChange, setvalueChange] = useState({
    gender1: "Male",
    gender2: "Male",
    bloodGroup1: "A+",
    bloodGroup2: "A+",
  });
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleChange = (e) => {
    setvalueChange({ ...valueChange, [e.target.name]: e.target.value });
  };
  // const handletest = () => {
  // localStorage.setItem("RILReport_1", JSON.stringify(valueChange));
  // const storedState = localStorage.getItem("RILReport_1");
  // if (storedState !== null) {
  //   if (storedState) {
  //     const parsedState = JSON.parse(storedState);
  //     setvalueChange(parsedState);
  //   }
  // }
  // console.log(valueChange, "storedStatestoredStatestoredState");
  const handletest = () => {
    setshow(true);
    setTimeout(() => {
      const CreateThunk = async () => {
        let htmlPayload;
        htmlPayload = document.getElementById(
          "prescriptionReportWrap"
        ).innerHTML;
        // console.log(htmlPayload, "liki");
        // const payload = {
        //   patient_id: patientId,
        //   template_type: selectedTab,
        //   prescription_template: htmlPayload,
        // };
        const payload = {
          payload: {
            prescription_template: htmlPayload,
            patient_id: patientId,
            description: "",
            template_type: "RIL Report",
          },
        };

        
        props.loaderchange(true);
        const patentDetails = postPrescriptionTemplate(payload);
        const response = await dispatch(patentDetails);
        if (response?.payload?.status?.code === 200) {
          dispatch(secondPageTemplateId(response.payload.data.id));
          props.loaderchange(false);
          // navigate("/PatientView");
          dispatch(updatePrescriptionType("RIL Report-2"));
        } else {
          props.loaderchange("false");
          props.popupalert("true");
          props.popuptext("Network went wrong, Please try after some time.");
          // props.popuptext(response?.status?.message);
          setTimeout(() => {
            props.popupalert("false");
          }, 2000);
        }
      };
      CreateThunk();
    }, 500);
  };

  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = (value, options = {}) => {
    const { style = { border: "1px solid black" } } = options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const {
      style = { border: "1px solid black", textAlign: "center" },
      colspans = 1,
    } = options;
    return (
      <th colSpan={colspans} style={style}>
        {value}
      </th>
    );
  };
  // };
  return (
    <>
      <div
        style={{ backgroundColor: "white" }}
        className="patientreport"
        id="reportcreate"
      >
        <>
          <div style={{ width: "100%" }}>
            <img
              className="header_image"
              // src={"https://s3.amazonaws.com/likodi.com/ascslogo.png"}
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: "100%",
                margin: "0 auto",
              }}
            ></img>
          </div>
        </>
        <div
          style={{
            // maxWidth: "97%",
            // margin: "0 auto",
            // border: "1px solid",
            borderTop: "none",
            // paddingTop: "10px",
            // display: "flex",
            // justifyContent: "center",
            // alignContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={props.patientsData.p_uhid}
                  onChange={(e) => handleChange(e)}
                  name="patientId"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.p_uhid}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name="patientName"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={valueChange.gender1}
                  name="gender"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.gender}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={props.patientsData.age}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{props.patientsData.age}
              </span>
            </div>
          </div>
          <table
            style={{
              borderSpacing: "0",
              // marginBottom: "30px",
              width: "98%",
            }}
          >
            <thead style={{ border: "1px solid", padding: "0px" }}>
              <tr
                style={{
                  border: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <th style={{ border: "1px solid", padding: "10px" }}>
                  Factors
                </th>
                <th style={{ border: "1px solid", padding: "10px" }}>DATE</th>
                <th style={{ border: "1px solid", padding: "10px" }}>
                  Results
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  UTERINE FACTORS
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
              {/* 3D USG/SIS-R/O Endo polyp */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;3D USG/SIS-R/O Endo polyp
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="dusgDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.dusgDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="dusgRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.dusgRemark}
                  </span>
                </td>
              </tr>
              {/* Hysteroscopy-Septum, Adhesions */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Hysteroscopy-Septum, Adhesions
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="hysteroscopyDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.hysteroscopyDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="hysteroscopyRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.Remark}
                  </span>
                </td>
              </tr>
              {/* ERA */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;ERA
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="eraDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.eraDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="eraRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.eraRemark}
                  </span>
                </td>
              </tr>
              {/* ADENOMYOSIS/FIBROID */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;ADENOMYOSIS/FIBROID
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="ADENOMYOSISDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.ADENOMYOSISDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="ADENOMYOSISRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.ADENOMYOSISRemark}
                  </span>
                </td>
              </tr>
              {/* EMPTY */}
              {/* <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr> */}
              {/* ENDOMETRIAL FACTORS */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  ENDOMETRIAL FACTORS
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
              {/* NC-HRT/PRP/G-CSF/Hysteroscopic stem cells/Tamoxifen/ Pentoxifylline/Estrogen gel/Endometrial scratching */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;NC-HRT/PRP/G-CSF/Hysteroscopic stem cells/Tamoxifen/
                  Pentoxifylline/Estrogen gel/Endometrial scratching
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="TamoxifenDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.TamoxifenDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="TamoxifenRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.TamoxifenRemark}
                  </span>
                </td>
              </tr>
              {/* Surrogacy-last option for refractory thin endometrium */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Surrogacy-last option for refractory thin endometrium
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="SurrogacyDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.SurrogacyDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="SurrogacyRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.SurrogacyRemark}
                  </span>
                </td>
              </tr>
              {/* HYALURONIC ACID-ENRICHED TRANSFER MEDIUM*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;HYALURONIC ACID-ENRICHED TRANSFER MEDIUM
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="haetmDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.haetmDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="haetmRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.haetmRemark}
                  </span>
                </td>
              </tr>

              {/* EMPTY */}
              {/* <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr> */}
              {/* TUBAL FACTORS */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  TUBAL FACTORS
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
              {/*3D USG/laparoscopy-hydrosalpinx*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;3D USG/laparoscopy-hydrosalpinx
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="hydrosalpinxDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.hydrosalpinxDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="hydrosalpinxRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.hydrosalpinxRemark}
                  </span>
                </td>
              </tr>

              {/* EMPTY */}
              {/* <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr> */}
              {/* AUTOIMMUNE DISORDERS */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  AUTOIMMUNE DISORDERS
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
              {/*ANA, IL-6, TNF alpha, NK CELLS*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;ANA, IL-6, TNF alpha, NK CELLS
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="tnfDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.tnfDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="tnfRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.tnfRemark}
                  </span>
                </td>
              </tr>
              {/*Peripheral blood T1/T2 cell ratio*/}
              {/* //*---------------------------- */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span>
                    <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                    &nbsp;Peripheral blood T1/T2 cell ratio
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="ratioDate"
                    style={{
                      padding: "10px",
                      outline: "none",
                      border: "0px",
                    }}
                    type="date"
                  ></input>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="ratioRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.ScreeningsRemark}
                  </span>
                </td>
              </tr>
              {/* //*---------------------------- */}
              {/* //*---------------------------- */}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span>
                    <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                    &nbsp;HLA-G polymorphism
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="polymorphismDate"
                    style={{
                      padding: "10px",
                      outline: "none",
                      border: "0px",
                    }}
                    type="date"
                  ></input>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="polymorphismRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.ScreeningsRemark}
                  </span>
                </td>
              </tr>
              {/* //*---------------------------- */}

              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <span>
                      <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                      &nbsp;CD56+ NK cells and IL-15/Fn14 gene expression ratios
                    </span>
                  </div>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{valueChange.ratioDate}
                    </span>

                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{valueChange.polymorphismDate}
                    </span>
                    <input
                      className={`createTime ${show ? "hide" : "show"}`}
                      onChange={(e) => handleChange(e)}
                      name="expressionDate"
                      style={{
                        padding: "10px",
                        outline: "none",
                        border: "0px",
                      }}
                      type="date"
                    ></input>
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{valueChange.expressionDate}
                    </span>
                  </div>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{valueChange.ratioRemark}
                    </span>

                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{valueChange.polymorphismRemark}
                    </span>
                    <input
                      type="text"
                      className={`createTime ${show ? "hide" : "show"}`}
                      onChange={(e) => handleChange(e)}
                      name="expressionRemark"
                      style={{
                        border: "1px solid #ddd",
                        outline: "none",
                        padding: "10px",
                        //   width: "100",
                      }}
                    />
                    <span className={`input ${!show ? "hide" : "show"}`}>
                      &nbsp;{valueChange.expressionRemark}
                    </span>
                  </div>
                </td>
              </tr>
              {/*Thrombophilia Screening*/}

              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Thrombophilia Screening
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="ScreeningsDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.ScreeningsDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="ScreeningsRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.ScreeningsRemark}
                  </span>
                </td>
              </tr>
              {/*HBA1C*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;Antithyroid Antibodies
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="AntibodiesDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.AntibodiesDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="AntibodiesRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.AntibodiesRemark}
                  </span>
                </td>
              </tr>
              {/*EMPTY*/}
              {/* <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr> */}
              {/*ENDOCRINE FACTORS*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  ENDOCRINE FACTORS
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr>
              {/*TSH/PROLACTIN/GTT/HBAIC*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;TSH/PROLACTIN/GTT/HBAIC
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="PROLACTINDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.PROLACTINDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="PROLACTINRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.PROLACTINRemark}
                  </span>
                </td>
              </tr>
              {/*VITAMIN D LEVELS*/}
              <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <span style={{ paddingLeft: "10px" }}>&nbsp;&#8226;</span>
                  &nbsp;VITAMIN D LEVELS
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="VITAMINDate"
                    style={{ padding: "10px", outline: "none", border: "0px" }}
                    type="date"
                  ></input>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.VITAMINDate}
                  </span>
                </td>
                <td style={{ border: "1px solid", padding: "10px" }}>
                  <input
                    type="text"
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChange(e)}
                    name="VITAMINRemark"
                    style={{
                      border: "1px solid #ddd",
                      outline: "none",
                      padding: "10px",
                      //   width: "100",
                    }}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange.VITAMINRemark}
                  </span>
                </td>
              </tr>

              {/*Empty*/}
              {/* <tr
                style={{
                  borderBottom: "1px solid",
                  borderSpacing: "0px",
                  borderCollapse: "collapse",
                }}
              >
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
                <td style={{ border: "1px solid", padding: "10px" }}></td>
              </tr> */}
            </tbody>
          </table>
        </div>
      </div>

      {/* Footer */}
     
      <div className="Footer">
        <button onClick={handletest} className="Button_Create">
          Next Page
        </button>
      </div>
      <div id="prescriptionReport">
        <div id="prescriptionReportWrap">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>
          <div>
            <table style={{ width: "100%" }}>
              <thead>
                <tr>
                  {renderTableTH("Factors")}
                  {renderTableTH("Date")}
                  {renderTableTH("Results")}
                </tr>
              </thead>
              <tbody>
                <tr>{renderTableTH("UTERINE FACTORS", { colspans: 3 })}</tr>
                {[
                  " • 3D USG/SIS-R/O Endo polyp",
                  " • Hysteroscopy-Septum, Adhesions",
                  " • ERA",
                  " • ADENOMYOSIS/FIBROID",
                ].map((ele, ind) => {
                  let value = [
                    "dusgDate||dusgRemark",
                    "hysteroscopyDate||hysteroscopyRemark",
                    "eraDate||eraRemark",
                    "ADENOMYOSISDate||ADENOMYOSISRemark",
                  ];
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele)}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[0]}`]
                          ?.split("-")
                          .reverse()
                          .join("-")
                      )}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[1]}`]
                      )}
                    </tr>
                  );
                })}
                <tr>{renderTableTH("ENDOMETRIAL FACTORS", { colspans: 3 })}</tr>
                {[
                  " • NC-HRT/PRP/G-CSF/Hysteroscopic stem cells/Tamoxifen/ Pentoxifylline/Estrogen gel/Endometrial scratching",
                  " • Surrogacy-last option for refractory thin endometrium",
                  " • HYALURONIC ACID-ENRICHED TRANSFER MEDIUM",
                ].map((ele, ind) => {
                  let value = [
                    "TamoxifenDate||TamoxifenRemark",
                    "SurrogacyDate||SurrogacyRemark",
                    "haetmDate||haetmRemark",
                  ];
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele)}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[0]}`]
                          ?.split("-")
                          .reverse()
                          .join("-")
                      )}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[1]}`]
                      )}
                    </tr>
                  );
                })}
                <tr>{renderTableTH("TUBAL FACTORS", { colspans: 3 })}</tr>
                {[" • 3D USG/laparoscopy-hydrosalpinx"].map((ele, ind) => {
                  let value = ["hydrosalpinxDate||hydrosalpinxRemark"];
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele)}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[0]}`]
                          ?.split("-")
                          .reverse()
                          .join("-")
                      )}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[1]}`]
                      )}
                    </tr>
                  );
                })}
                <tr>
                  {renderTableTH("AUTOIMMUNE DISORDERS", { colspans: 3 })}
                </tr>
                {[
                  " • ANA, IL-6, TNF alpha, NK CELLS",
                  " • Peripheral blood T1/T2 cell ratio",
                  " • HLA-G polymorphism",
                  " • CD56+ NK cells and IL-15/Fn14 gene expression ratios",
                  " • Thrombophilia Screening",
                  " • Antithyroid Antibodies",
                ].map((ele, ind) => {
                  let value = [
                    "tnfDate||tnfRemark",
                    "ratioDate||ratioRemark",
                    "polymorphismDate||polymorphismRemark",
                    "expressionDate||expressionRemark",
                    "ScreeningsDate||ScreeningsRemark",
                    "AntibodiesDate||AntibodiesRemark",
                  ];
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele)}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[0]}`]
                          ?.split("-")
                          .reverse()
                          .join("-")
                      )}
                      {renderTableTD(
                        valueChange[`${value[ind].split("||")[1]}`]
                      )}
                    </tr>
                  );
                })}
                <tr>{renderTableTH("ENDOCRINE FACTORS", { colspans: 3 })}</tr>
                {[" • TSH/PROLACTIN/GTT/HBAIC", " • VITAMIN D LEVELS"].map(
                  (ele, ind) => {
                    let value = [
                      "PROLACTINDate||PROLACTINRemark",
                      "VITAMINDate||VITAMINRemark",
                    ];
                    return (
                      <tr key={ind}>
                        {renderTableTD(ele)}
                        {renderTableTD(
                          valueChange[`${value[ind].split("||")[0]}`]
                            ?.split("-")
                            .reverse()
                            .join("-")
                        )}
                        {renderTableTD(
                          valueChange[`${value[ind].split("||")[1]}`]
                        )}
                      </tr>
                    );
                  }
                )}
              </tbody>
            </table>
          </div>
          
          {/* <p class="Dani"></p> */}
        </div>
      </div>
    </>
  );
}

export default RilReportTemplate;
